import React from 'react';
import { Link } from 'react-router-dom';
import { companyData } from '../data';
import { useLanguage } from '../context/LanguageContext';
import { Phone, Mail, MapPin } from 'lucide-react';
import { getOptimizedImageUrl } from '../lib/utils';

export default function Footer() {
  const { lang, t, navigation } = useLanguage();

  return (
    <footer className="bg-slate-950 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-slate-800">
          <div>
            <img
              className="h-16 w-auto mb-6 brightness-0 invert"
              src={getOptimizedImageUrl(companyData.logo, 150, 90)}
              alt={`${companyData.name} Logo`}
            />
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              {t('footer.desc')}
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest mb-6 text-white">
              {t('footer.contact')}
            </h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">
                <Phone size={18} className="text-blue-500" />
                <a href={`tel:${companyData.phoneClean}`}>{companyData.phone}</a>
              </li>
              <li className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">
                <Mail size={18} className="text-blue-500" />
                <a href={`mailto:${companyData.email}`}>{companyData.email}</a>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <MapPin size={18} className="text-blue-500" />
                <span>{companyData.address[lang]}</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest mb-6 text-white">
              {t('footer.shortcuts')}
            </h3>
            <div className="grid grid-cols-1 gap-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-slate-400 hover:text-white text-sm transition-colors"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
        
        <div className="mt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-slate-500 text-xs uppercase tracking-widest">
          <p>© {new Date().getFullYear()} {companyData.name}. {t('footer.allRightsReserved')}</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-white">{lang === 'da' ? 'Privatlivspolitik' : 'Privacy Policy'}</Link>
            <Link to="#" className="hover:text-white">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
